import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';
import { getFunctions } from 'firebase/functions';

export const firebaseConfig = {
  apiKey: "AIzaSyBhUt8-xyq53kN8UCBcUrJkDbShTdiZQ8E",
  authDomain: "dads-hub-595f5.firebaseapp.com",
  projectId: "dads-hub-595f5",
  storageBucket: "dads-hub-595f5.firebasestorage.app",
  messagingSenderId: "788785788864",
  appId: "1:788785788864:web:8a6444e80a13acf544ba25",
  measurementId: "G-3731RPWJEV"
};

// Initialize Firebase
// This check prevents double initialization in some hot-reload environments
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

// Only initialize messaging if supported (e.g. not in Safari private browsing or unsupported desktop browsers)
export let messaging: any = null;
isSupported().then((supported) => {
    if (supported) {
        messaging = getMessaging(app);
    }
});

export default app;